/**
*time: 2023/10/25
*/
<template>
  <div class="listContent">
    <a-form :form="form" class="headForm" labelAlign="left">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="原料">
            <a-select v-decorator="['rawSearchKey']" allowClear show-search placeholder="请输入原料名称/代码"
              :default-active-first-option="false" :show-arrow="false" :filter-option="false" @search="handleRawSearch"
              @select="handleRawSelect">
              <template slot="notFoundContent">
                <a-spin v-if="searchLoading" size="small" />
                <span v-else>无匹配结果</span>
              </template>
              <a-select-option v-for="d in rawSearchList" :key="d.rawId">
                {{ d.firstName }}<span style="color: red">{{ d.midName }}</span>{{ d.lastName }}({{
                d.code }})
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="指标">
            <a-select v-decorator="['nutritionSearchKey']" allowClear show-search placeholder="请输入指标名称/代码"
              :default-active-first-option="false" :show-arrow="false" :filter-option="false"
              @search="handleNutritionSearch" @select="handleNutritionSelect">
              <template slot="notFoundContent">
                <a-spin v-if="nutritionSearchLoading" size="small" />
                <span v-else>无匹配结果</span>
              </template>
              <a-select-option v-for="d in nutritionSearchList" :key="d.id">
                {{ d.name }}({{ d.fullName || d.code }})
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="日期">
            <a-range-picker v-decorator="['date']" class="search_content_class" :locale="locale" />
          </a-form-item>
        </a-col>
        <a-col :span="6" class="submitBtnBox">
          <a-button type="primary" class="btnMar" @click="getList({ current: 1, pageSize: pagination.pageSize })">
            查询
          </a-button>
          <a-button class="btnMar" @click="resetFields">
            清空
          </a-button>
<!--          <a-button @click="handleExport">-->
<!--            导出数据-->
<!--          </a-button>-->
        </a-col>
      </a-row>
    </a-form>
    <div class="content_class">
      <a-table ref="listRef" :scroll="{ y, x: 1000 }" class="tableBox" :columns="columns" :data-source="list"
        :pagination="pagination" :locale="locale" rowKey="id" :loading="loading">
        <template v-for="el in ['oldValue', 'newValue', 'diffValue']" :slot="el" slot-scope="text">
          <span :key="el">{{ formatDecimal(text) }}</span>
        </template>
      </a-table>
    </div>

    <!-- 添加文件名输入弹窗 -->
    <a-modal title="导出" :visible="exportModalVisible" @ok="confirmExport" @cancel="cancelExport" :maskClosable="false"
      :confirm-loading="exportLoading" width="400px">
      <a-row type="flex" justify="center" align="middle">
        <a-col :span="4">
          <span style="font-size: smaller;"><span style="color: red;">*</span>文件名：</span>
        </a-col>
        <a-col :span="20">
          <a-input v-model="exportFileName" placeholder="请输入文件名称" />
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>
<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import _ from 'lodash';

const columns = [
  {
    title: '编辑时间',
    dataIndex: 'createTime',
    align: 'center',
  },
  {
    title: '原料名称',
    dataIndex: 'rawName',
    align: 'center',
  },
  {
    title: '原料代码',
    dataIndex: 'rawCode',
    align: 'center',
  },
  {
    title: '指标名称',
    dataIndex: 'nutritionName',
    align: 'center',
  },
  {
    title: '指标代码',
    dataIndex: 'nutritionCode',
    align: 'center',
  },
  {
    title: '原值',
    dataIndex: 'oldValue',
    align: 'center',
    scopedSlots: { customRender: 'oldValue' },
  },
  {
    title: '新值',
    dataIndex: 'newValue',
    align: 'center',
    scopedSlots: { customRender: 'newValue' },
  },
  {
    title: '差异',
    dataIndex: 'diffValue',
    align: 'center',
    scopedSlots: { customRender: 'diffValue' },
  },
  {
    title: '单位',
    dataIndex: 'convertUnitName',
    align: 'center',
  },
  {
    title: '编辑用户',
    dataIndex: 'createUserName',
    align: 'center',
  },
];

export default {
  name: 'MaterialMaintenanceRecord',
  data() {
    return {
      y: 500,
      form: this.$form.createForm(this, { name: 'MaterialMaintenanceRecord' }),
      locale,
      rawSearchList: [],
      searchLoading: false,
      handleRawSearch: null,
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.pagination.pageSize = pageSize;
          this.getList();
        },
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize;
          this.pagination.current = 1;
          this.getList({ current: 1, pageSize });
        }
      },
      columns,
      list: [],
      loading: false,
      nutritionSearchList: [],
      nutritionSearchLoading: false,

      exportModalVisible: false,
      exportFileName: '原料数据库维护记录',
      exportLoading: false,
    };
  },
  created() {
    this.getList();
    this.handleRawSearch = _.debounce((keyword) => {
      if (keyword) {
        this.rawSearchList = [];
        this.searchLoading = true;
        let params = {
          factoryId: window.localStorage.getItem('factoryId'),
          current: 1,
          size: 20,
          name: keyword
        };
        this.$get('/nhf-app/factorystaffraw/myRawpage', params).then(res => {
          let { success, data } = res;
          if (success) {
            let { records } = data;
            records.map(el => {
              let nameArr = el.name.split(keyword);
              el.firstName = nameArr[0] || '';
              el.lastName = nameArr[1] || '';
              el.midName = keyword;
              return el;
            });
            this.rawSearchList = records || [];
          } else {
            this.rawSearchList = [];
          }
          this.searchLoading = false;
        }).catch(() => {
          this.rawSearchList = [];
          this.searchLoading = false;
        });
      } else {
        this.rawSearchList = [];
      }
    }, 300);

    this.handleNutritionSearch = _.debounce((keyword) => {
      if (keyword) {
        this.nutritionSearchList = [];
        this.nutritionSearchLoading = true;
        let params = {
          factoryId: window.localStorage.getItem('factoryId'),
          current: 1,
          size: 20,
          searchKey: keyword
        };
        this.$get('/nhf-core-data/nutritiontarget/nutritionUserPage', params).then(res => {
          let { success, data } = res;
          if (success) {
            let { records } = data;
            this.nutritionSearchList = records || [];
          } else {
            this.nutritionSearchList = [];
          }
          this.nutritionSearchLoading = false;
        }).catch(() => {
          this.nutritionSearchList = [];
          this.nutritionSearchLoading = false;
        });
      } else {
        this.nutritionSearchList = [];
      }
    }, 300);
  },
  mounted() {
    this.y = this.$refs.listRef.$el.offsetHeight - 116;
  },
  methods: {
    resetFields() {
      this.form.resetFields();
    },
    formatDecimal(value) {
      if (value === undefined || value === null || value === '') {
        return '';
      }
      return Number(value).toFixed(3);
    },
    getList(pagination) {
      let { current, pageSize } = pagination || this.pagination;
      this.loading = true;

      this.form.validateFields((err, values) => {
        let { date, ...newValues } = values || {};
        let params = {
          query: {
            current,
            size: pageSize,
          },
          timeStart: date && date.length ? moment(date[0]).format('YYYY-MM-DD 00:00:00') : undefined,
          timeEnd: date && date.length ? moment(date[1]).format('YYYY-MM-DD 23:59:59') : undefined,
          rawId: newValues.rawSearchKey ? newValues.rawSearchKey : undefined,
          nutritionId: newValues.nutritionSearchKey ? newValues.nutritionSearchKey : undefined,
          status: 1
        };
        this.$post('/iot-log/cloudnutritiondatarecord/pageCloudNutritionDataRecord', params).then(res => {
          let { success, data } = res;
          if (success) {
            let { records, current = 1, total = 0 } = data;
            this.pagination.current = current;
            this.pagination.total = total;
            this.list = records || [];
          } else {
            this.$message.error('查询失败');
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      });
    },
    handleExport() {
      // 设置默认文件名
      this.exportFileName = '原料数据库维护记录';
      // 显示导出文件名输入弹窗
      this.exportModalVisible = true;
    },
    cancelExport() {
      this.exportModalVisible = false;
    },
    confirmExport() {
      if (!this.exportFileName || this.exportFileName.trim() === '') {
        this.$message.error('请输入文件名');
        return;
      }
      this.exportLoading = true;

      // 获取之前保存的表单值
      let { date, nutritionTypeId, ...newValues } = this.exportFormValues || {};

      // 如果选择了指标类型，取最后一个值作为查询条件
      const typeId = nutritionTypeId && nutritionTypeId.length ? nutritionTypeId[nutritionTypeId.length - 1] : undefined;

      let params = {
        fileName: this.exportFileName,
        query: {
          current: 1,
          size: this.pagination.pageSize,
        },
        timeStart: date && date.length ? moment(date[0]).format('YYYY-MM-DD 00:00:00') : undefined,
        timeEnd: date && date.length ? moment(date[1]).format('YYYY-MM-DD 23:59:59') : undefined,
        rawId: newValues.rawSearchKey ? newValues.rawSearchKey : undefined,
        nutritionId: newValues.nutritionSearchKey ? newValues.nutritionSearchKey : undefined,
        nutritionTypeId: typeId,
        status: newValues.status !== undefined ? newValues.status : undefined,
      };

      this.$post('/iot-log/cloudnutritiondatarecord/asyncExportCloudNutritionDataRecord', params).then(res => {
        let { success } = res;
        if (success) {
          this.$message.success('导出任务已提交，请稍后在下载中心查看');
          // 关闭弹窗
          this.exportModalVisible = false;
        } else {
          this.$message.error('导出失败');
        }
      }).catch(() => {
        this.$message.error('导出失败');
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    handleRawSelect(value) {
      console.log(value);
      this.getList({ current: 1, pageSize: this.pagination.pageSize });
    },
    handleNutritionSelect(value) {
      console.log(value);
      this.getList({ current: 1, pageSize: this.pagination.pageSize });
    },
  }
};
</script>
<style lang="scss" scoped>
.listContent {
  background-color: #fff;
  padding: 10px;

  .headForm {
    margin-bottom: 20px;
    padding: 10px;
  }

  .submitBtnBox {
    .btnMar {
      margin-right: 10px;
    }
  }

  .content_class {
    background-color: #fff;
    border-radius: 5px;
    height: calc(100% - 80px);
  }
}

.tableBox {
  padding: 0;
  height: calc(100vh - 250px);
}
</style>
